"use client";

import { ChartLegend, type LegendItem } from "@/components/chart/components/Legend";
import { useIsDarkMode } from "@/utils/colorScheme";

type ChatTimeseriesLegendFooterProps = {
  items: LegendItem[];
};

/** Series legend below the chart surface (replaces as-at / units footer on performance embeds). */
export function ChatTimeseriesLegendFooter({ items }: ChatTimeseriesLegendFooterProps) {
  const isDark = useIsDarkMode();

  return (
    <div
      className="mt-2 border-t border-slate-200/60 pt-2 text-[11px] leading-snug text-slate-500 dark:border-slate-700/50 dark:text-slate-400"
      data-testid="chat-embed-chart-legend"
    >
      <ChartLegend
        items={items}
        position="bottom"
        mode="inline"
        showValues={false}
        isDarkMode={isDark}
        matchItemsByIndex
        showFullLabelTitle
        className="!justify-start text-[11px]"
      />
    </div>
  );
}
